import ReactMarkdown from "react-markdown";

const Markdown = ReactMarkdown;
export default Markdown;
